export const DownloadInvoiceIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.042"
      height="14.042"
      viewBox="0 0 14.042 14.042"
    >
      <g
        id="Icon_feather-download"
        data-name="Icon feather-download"
        transform="translate(0.75 0.75)"
      >
        <path
          id="Path_229432"
          data-name="Path 229432"
          d="M17.042,22.5v2.779a1.391,1.391,0,0,1-1.394,1.389H5.894A1.391,1.391,0,0,1,4.5,25.279V22.5"
          transform="translate(-4.5 -14.126)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Path_229433"
          data-name="Path 229433"
          d="M10.5,15l4.038,4.27L18.576,15"
          transform="translate(-8.267 -10.265)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Path_229434"
          data-name="Path 229434"
          d="M18,16.211V7.5"
          transform="translate(-11.729 -7.5)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
};
